/**
 * /tenants/$slug/agents/standing-delegations — Standing delegations (AI Agents →
 * Agent governance). The unattended pre-authorizations an autonomous agent mints
 * against. Thin shim: validate the status filter, prefetch the list, mount the page.
 */

import { createFileRoute } from "@tanstack/react-router";
import {
  standingDelegationsSearchSchema,
  type StandingDelegationsSearch,
} from "@/features/agents/schemas";
import { fetchStandingDelegations } from "@/features/agents/queries";
import { queryKeys } from "@/lib/query-keys";
import { StandingDelegationsPage } from "@/features/agents/pages/standing-delegations-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/agents/standing-delegations",
)({
  validateSearch: (raw: Record<string, unknown>): StandingDelegationsSearch =>
    standingDelegationsSearchSchema.parse(raw),
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.agents.standingDelegations(context.tenant.id),
      queryFn: () => fetchStandingDelegations(context.tenant.id),
    }),
  component: StandingDelegationsPage,
});
